module.exports = __webpack_public_path__ + "static/media/angular-js.dd68dea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/angular-js.png
// module id = 528
// module chunks = 146